/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useMemo} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {ListSelectDropDown} from '@insticator/insticator-ui';

// utils
import {transpileDataForFilters} from '../../../../../../utils/transpilers/transpileDataForFilters';

// consts
import {FILTERS, SITES} from "../../consts";


/* ========== ~~~~~~~~~~ SITE FILTER ~~~~~~~~~~ ========== */

export default (props) => {
    // component props
    const {handleOnChange, filterValues} = props;

    // redux state
    const sitesAndApps = useSelector((state) => state.account.sitesAndApps)
    const selectedSites = useSelector((state) => state.app.filters.sites)
    const selectedSitesByType = useSelector((state) => state.app.filters.sitesByType)

    const items = useMemo(() =>
        transpileDataForFilters(sitesAndApps, true, true),
        [sitesAndApps]
    );

    const selected = useMemo(() => (filterValues[SITES] || []).length ?
        items.filter((item) => filterValues[SITES].includes(item.value)).reduce((acc, item) => {
            if (acc[item.type]) acc[item.type].push(item.value);
            else acc[item.type] = [item.value];
            return acc;
        },{}) : null,
        [items, filterValues]
    );

    return (
        <ListSelectDropDown
            klass={`filter-site`}
            name={'Domain/App'}
            items={items}
            selected={selected ? selected : (selectedSites.length ? selectedSitesByType : null)}
            noEmptyApply={true}
            paginated={true}
            itemsPerPage={50}
            buttonAction={
                sitesAndApps => {
                    let newValue = {...filterValues}
                    newValue[SITES] = Object.values(sitesAndApps).flat()
                    handleOnChange({[FILTERS]: newValue})
                }
            }
        />
    );
};
